import React, { useState } from 'react';
import './Navbar.css';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import ButtonFrame from '../snippets/ButtonFrame';
import { joinWaitlist } from '../action/functions';
import ToastMessage from '../snippets/ToastMessage';


const JoinWaitlist = ({closeJoinWaitlistModal}) => {

  const [emailAddress, setEmailAddress] = useState("")
  const [waitlist, setWaitlist] = useState(true);
  const [waitlistSuccess, setWaitlistSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msgAlert, setMsgAlert] = useState({
    active: false,
    message: "",
    status: "warning"
  });

  const openWaitListSuccess = () => {
    setWaitlist(false);
    setWaitlistSuccess(true);
  }

  const closeWaitListSuccess = () => {
    setWaitlistSuccess(false);
    closeJoinWaitlistModal();
  }

  const submit = async () => {
    setLoading(true);
    let data = {
      email: emailAddress
    };

    let result = await joinWaitlist(data);

    if (result.status) {

      setMsgAlert({
        active: true,
        message: result.data.message,
        status: "success"
      });
      setEmailAddress("");
      setLoading(false);
      openWaitListSuccess();    
    }else {
      setLoading(false);
      setMsgAlert({
        active: true,
        message: result.message,
        status: "warning"
      });
    }
  }

  return (
    <>
      {waitlist && (
        <div className="modal-overlay" onClick={closeJoinWaitlistModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <img src="/assets/close.png" alt="Close Icon" className='signup-close-icon' onClick={closeJoinWaitlistModal} />        
            <div className='waitlist-container'>
              <div className='waitlist-header'>
                <img src="/assets/young-woman-with-binoculars.svg" alt="binoculars" />      
                <h2 className="modal-title">Join Waitlist</h2>
              </div>
              <div className='waitlist-input-container'>
                <p className='verify-text'>We are launching soon with more exciting features! Be the first to know and get access to exclusive offers.</p>
                <div className='waitlist-inventory-notify-container'>
                  <div className='notify-container'>
                    <input
                      type='email'
                      placeholder='Enter Email Address'
                      className='notify-email-input'
                      value={emailAddress}
                      onChange={(e) => setEmailAddress(e.target.value)}
                      required
                    />
                    <ButtonFrame handleClick={() => submit()} loading={loading} btnText={"Notify me"} classNameStyle="notify-btn-topup" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {waitlistSuccess && (
        <div className="modal-overlay" onClick={closeWaitListSuccess}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <img src="/assets/close.png" alt="Close Icon" className='signup-close-icon' onClick={closeWaitListSuccess} />
              <div className='modal-main-container'>
                <DotLottieReact
                  src="/assets/party-pop.json"
                  loop
                  autoplay
                  className='canvas'
                />
                <div className='signup-modal-container'>
                  <h2 className="modal-title">Thank you!</h2>
                  <div className='modal-input-container'>
                    <p className='verify-text'>You'll be the first to know!</p>
                  </div>
                </div>
              </div>
          </div>
        </div>
      )}
      {msgAlert.active && <ToastMessage toastTitle={"Waitlist"} toastMessage={msgAlert.message} toastType={msgAlert.status} closeOut={() => setMsgAlert({...msgAlert, active:false})} />}
    </>
  );
};

export default JoinWaitlist;
